module.exports = __webpack_public_path__ + "img/C3.5T.b776dafe.svg";